import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sso-complete',
  templateUrl: './sso-complete.component.html',
  styleUrls: ['sso-complete.component.css']
})
export class SSOCompleteComponent implements OnInit {

  constructor() { }
  
  ngOnInit() {
  }

}
